import { render } from "./Drejtoriat_Sekretariati.vue?vue&type=template&id=fab9570e&scoped=true"
import script from "./Drejtoriat_Sekretariati.vue?vue&type=script&lang=js"
export * from "./Drejtoriat_Sekretariati.vue?vue&type=script&lang=js"

import "./Drejtoriat_Sekretariati.vue?vue&type=style&index=0&id=fab9570e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab9570e"]])

export default __exports__